import apiInstance from '../utils/axiosConfig';

const SettingsService = {
    // Créer un paramètre
    createSettings: async (settingsRequestDto) => {
        try {
            const response = await apiInstance.post('/settings/createSettings', settingsRequestDto);
            return response.data;
        } catch (error) {
            console.error('Error creating settings:', error.message || error);
            throw error;
        }
    },

    // Récupérer un paramètre par ID
    getSettingsById: async (id) => {
        try {
            const response = await apiInstance.get(`/settings/getSettingsById/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching settings by id:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les paramètres
    getAllSettings: async () => {
        try {
            const response = await apiInstance.get('/settings/getAllSettings');
            return response.data;
        } catch (error) {
            console.error('Error fetching all settings:', error.message || error);
            throw error;
        }
    },

    // Récupérer les paramètres actifs courants
    getCurrentSettings: async () => {
        try {
            const response = await apiInstance.get('/settings/getCurrentSettings');
            return response.data;
        } catch (error) {
            console.error('Error fetching current settings:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un paramètre
    updateSettings: async (id, settingsRequestDto) => {
        try {
            const response = await apiInstance.put(`/settings/updateSettings/${id}`, settingsRequestDto);
            return response.data;
        } catch (error) {
            console.error('Error updating settings:', error.message || error);
            throw error;
        }
    },

    // Supprimer un paramètre
    deleteSettings: async (id) => {
        try {
            await apiInstance.delete(`/settings/deleteSettings/${id}`);
        } catch (error) {
            console.error('Error deleting settings:', error.message || error);
            throw error;
        }
    }
};

export default SettingsService;